import { createReducer } from 'typesafe-actions';
import { buildLogs } from './actions';
import { BuildLogsResponse } from './types';
import { RequestStatus } from 'utils/types';

type State = {
  data: BuildLogsResponse | null;
  message: string | null;
  status: RequestStatus | null;
};

const initialState: State = {
  data: null,
  message: null,
  status: null,
};

const buildLogsReducer = createReducer(initialState)
  .handleAction(buildLogs.request, (state) => ({
    ...state,
    data: null,
    message: null,
    status: RequestStatus.PENDING,
  }))
  .handleAction(buildLogs.success, (state, action) => ({
    ...state,
    data: {
      ...action.payload,
    },
    message: null,
    status: RequestStatus.SUCCESS,
  }))
  .handleAction(buildLogs.failure, (state, action) => ({
    ...state,
    data: null,
    message: action.payload.message,
    status: RequestStatus.FAILED,
  }));

export default buildLogsReducer;
